module.exports = __webpack_public_path__ + "img/Rectangle70.565664e8.png";